import { FC } from 'react';
import { RecognitionsLayout } from 'pages/atoms';
import { RecognitionsRulesList } from 'containers/recognitions';

const RecognitionsRulesPage: FC = () => {
  return (
    <RecognitionsLayout>
      <RecognitionsRulesList />
    </RecognitionsLayout>
  );
};

export default RecognitionsRulesPage;
